module.exports = __webpack_public_path__ + "static/hero-banner-089462ebfa8dbdb4c00ff1ae9371f347.jpg";